import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DialogModal from '../../../components/dialogModal'
import QRCodeDownload from '../../../components/qrDownload'
import { NavBarCollapsableContext } from '../../../helpers/context'
import CreateNewFormQr from '../../../components/forms/qrCodes/formCreate'
import { createLink } from '../../../redux/reducers/urlReducer'
import { AppDispatch, useAppDispatch } from '../../../redux/store'
import { getToken, getTokenExpiration, logOut } from '../../../helpers/utils'
import { toast } from 'react-toastify'
import { getInfo } from '../../../redux/reducers/userReducer'
import { useNavigate } from 'react-router-dom'

type qrValues = {
  color: string
  logo: string
}

type QrValues = {
  url: string
  domain: string
  title: string
  custom_code: string
  has_qr: boolean
  qr_code: qrValues
}

interface Info {
  credits: {
    url: number
    qr: number
  }
  permissions: {
    custom_domain: true
    custom_post_domain: true
    has_qr: true
  }
  domains: string[]
  hasQrCredits: boolean
  hasUrlCredits: boolean
  plan: string
}

const CreateNewQr = () => {
  const dispatch: AppDispatch = useAppDispatch()
  const { t } = useTranslation()
  const classContext = useContext(NavBarCollapsableContext)
  const [openModal, setOpenModal] = useState(false)
  const [openModalPlan, setOpenModalPlan] = useState(false)
  const [shortUrlCreated, setShortUrlCreated] = useState(false)
  const [data, setData] = useState<any>({})
  const [userInfo, setUserInfo] = useState<Info>()
  const token = getToken()
  const sessionExpired = getTokenExpiration()
  let navigate = useNavigate()

  useEffect(() => {
    if (sessionExpired) logOut()
  }, [sessionExpired])

  useEffect(() => {
    getUserInfo()
  }, [])

  const getUserInfo = async () => {
    try {
      const { payload } = await dispatch(
        getInfo({
          token: token,
        })
      )
      if (payload?.success) {
        setUserInfo(payload?.data)
        if (payload.data.credits.qr === 0) {
          setOpenModalPlan(true)
        }
      } else {
        console.error(`${t('ERROR')}`)
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const handleSubmit = async (values: QrValues) => {
    getUserInfo()
    const urlData = {
      url: values.url,
      domain: values.domain,
      title: values.title,
      custom_code: values.custom_code,
      has_qr: true,
      qr_code: { color: values.qr_code.color, logo: values.qr_code.logo },
      utm: null,
    }

    try {
      const { payload } = await dispatch(createLink({ token, body: urlData }))

      if (payload && payload.success) {
        setShortUrlCreated(true)
        setData(payload?.data)
        setOpenModal(true)
      } else {
        toast(payload.message)
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }
  const handleCloseModalPlans = () => {
    setOpenModalPlan(false)
  }

  return (
    <>
      <div className={`container-home background-white`}>
        <div className={classContext.classes.navbar_padding_left}>
          <div className='d-grid'>
            <span className='principal-title'>{`${t('CREATE_NEW')}`}</span>
            <span
              dangerouslySetInnerHTML={{ __html: `${t('QR_CODE_INFO')}` }}
            />
          </div>
          {userInfo && (
            <CreateNewFormQr
              userInfo={userInfo}
              canCreateQR={userInfo.hasQrCredits}
              domains={userInfo?.domains}
              onSubmit={handleSubmit}
              shortUrlGenerated={data.short_url}
              url=''
              domain=''
              title=''
              custom_code=''
              has_qr={true}
              qr_code={{
                color: '',
                logo: '',
              }}
            />
          )}
        </div>
      </div>
      {shortUrlCreated && (
        <DialogModal
          title={`${t('QR_CREATED')}`}
          open={openModal}
          handleClose={handleCloseModal}
          className='modal-top-red'
        >
          <>
            <div className='d-flex flex-column align-items-center'>
              <QRCodeDownload qrData={data} />
            </div>
          </>
        </DialogModal>
      )}

      <DialogModal
        title={`${t('CHANGE_PLAN_QR')}`}
        open={openModalPlan}
        handleClose={handleCloseModalPlans}
        className='modal-top-red'
      >
        <div className='d-flex link-card-button-container'>
          <button
            disabled={false}
            onClick={() => navigate(`/plans`)}
            className='button-first my-4'
          >
            {`${t('ACCEPT')}`}
          </button>
          <button
            disabled={false}
            onClick={() => setOpenModalPlan(false)}
            className='button-seventh my-4'
          >
            {`${t('CLOSE')}`}
          </button>
        </div>
      </DialogModal>
    </>
  )
}

export default CreateNewQr
